/* eslint-disable prefer-const */
/* eslint-disable no-debugger */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { IOutlookAppointmentService, TokenIOutlookAppointmentService } from "@/out-look/services";
import { baContainer } from "../../ioc";
import { ResourceInfo } from "../resource-service/entity/ResourceEntity";
import { IOrderService } from "./IOrderService";
import { ProcessWorkspaceRulesResult } from "./entity/ProcessWorkspaceRulesResult";
import { UidGenerator } from "@/shared/utilities/UidGenerator";
import { ProcessMovingOrderRequest } from "./entity/request/ProcessMovingOrderRequest";
import { CheckResourceMovingOrderResult } from "./entity/CheckResourceMovingOrderResult";
import { IOrganizationService, TokenIOrganizationService } from "../organization-service";
import { HttpClientNormal } from "@/fetchInterceptor/HttpClient";
// import { SavePlaceOrderSessionDataRequest } from "./entity/request/SavePlaceOrderSessionDataRequest";
import { AxiosResponse } from "axios";
import { convertToNetTicks, DialogMessageBase, IHash } from "@/shared";
import { DialogChosenEnum, IDialogService, OutlookRecipientDto, TokenIDialogService } from "@/out-look/interfaces";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { DialogEventType, IDialogModel } from "./entity/IDialogModel";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ContextEnum, DialogErrorCode, OfficeDialogMessageType } from "@/common/enums";
// import { ApiUrl } from "@/fetchInterceptor/ApiUrl";
import { ISettingStore } from "@/redux/slices/settings/SettingModel";
import { AttendeeInfo } from "../attendee-service/entity/AttendeeEntity";
import { IOrganizationStore } from "@/redux/slices/organizations/OrganizationModel";
import { IAuthenticationService, TokenIAuthenticationService } from "@/authentication";
import { config } from "@/config";
import { v4 } from "uuid";
import { UpdateOrderMessage } from "@/shared/classes/UpdateOrderMessage";
import { UpdateAttendeesMessage } from "@/shared/classes/UpdateAttendeesMessage";
import { PlaceOrderDialogAttendee } from "@/shared/classes/PlaceOrderDialogAttendee";
import { HttpResponse } from "@/fetchInterceptor/AxiosMethod";
import { SaveSessionDataRequest } from "./entity/request/SaveSessionDataRequest";
import { ClearSessionDataRequest } from "./entity/request/ClearSessionDataRequest";
import { IRcResourceService, TokenIRcResourceService } from "../rc-resource-service";
import { CheckSuitableForMovingOrderEnum } from "./entity/CheckSuitableForMovingOrderEnum";
import { CheckExternalResourcesRequest } from "../rc-resource-service/entity/request";
import { CheckResourceSuitableForMovingOrderResponse } from "./entity/response/CheckResourceSuitableForMovingOrderResponse";
import { MovingOrderSessionModel } from "./entity/MovingOrderSessionModel";
import { IAlertButton } from "../notification-service/entity/NotificationEntity";
import { OrderDataRequest } from "../rc-resource-service/entity/OrderDataRequest";
import { formatDateToRc } from "@/utilities/FormatDateToRc";
import moment from "moment";

export class OrderService implements IOrderService {
  private http: HttpClientNormal = new HttpClientNormal();
  private readonly _olAptService: IOutlookAppointmentService;
  private readonly _olOrganizerService: IOrganizationService;
  private readonly _dialogService: IDialogService;
  private readonly _authenticationService: IAuthenticationService;
  private _placeOrderDialogHandler?: IDialogModel | null;
  private _movingOrderSession?: MovingOrderSessionModel;

  private accessToken?: string;

  private _bookingEditSessionKey: string;
  private _isShownDeadlineMessage: boolean;
  private _isPlacedOrderDialogShown: boolean;
  private _baseUrl: string;

  constructor() {
    this._olAptService = baContainer.resolve(TokenIOutlookAppointmentService);
    this._olOrganizerService = baContainer.resolve(TokenIOrganizationService);
    this._dialogService = baContainer.resolve(TokenIDialogService);
    this._authenticationService = baContainer.resolve(TokenIAuthenticationService);
    // this._appSettingsService = baContainer.resolve(TokenIApplicationSettingsService);

    this._bookingEditSessionKey = UidGenerator.NewUid();
    this._isShownDeadlineMessage = false;
    this._isPlacedOrderDialogShown = false;
    this._baseUrl = "";
  }

  // async SavePlaceOrderSessionData(RESOURCE_CENTRAL_ENDPOINT: string | null | undefined, request: SavePlaceOrderSessionDataRequest): Promise<boolean> {
  //   const url = RESOURCE_CENTRAL_ENDPOINT + "/ResourceCentral/api/OfficeApp/SaveSessionData";
  //   return this.http.post(url, request).then((response: AxiosResponse<boolean>) => response.data); // Return the response data directly
  // }
  public get MovingOrderSession(): MovingOrderSessionModel | undefined {
    return this._movingOrderSession;
  }
  public SaveMovingOrderSession(movingOrderSession: MovingOrderSessionModel): void {
    this._movingOrderSession = { ...movingOrderSession };
  }

  public ReleaseMovingOrderSession(): void {
    this._movingOrderSession = undefined;
  }

  ShowPlaceOrderDialog(disableOrderForm: boolean, currentResource: ResourceInfo, selectedResources: ResourceInfo[], attendees: AttendeeInfo[], settings: ISettingStore, orgStore: IOrganizationStore) {
    this._processPlaceOrderDialog(disableOrderForm || false, currentResource, selectedResources, attendees, settings, orgStore);
  }
  public async ShowViewOrderDialog(selectedResources: ResourceInfo[], OldResource: ResourceInfo, settings: ISettingStore, orgStore: IOrganizationStore): Promise<void> {
    const organizer = await this._olOrganizerService.GetCurrentOrganizer();

    if (!this.accessToken) {
      const accessToken = await this._authenticationService.GetCallbackToken();
      this.accessToken = accessToken;
    }

    return new Promise<void>((resolve) => {
      const currentAppointment = this._olAptService.GetCurrentAppointment();
      if (currentAppointment) {
        const sessionId = v4();
        const urlSaveDataSession: string = `${config.API_URL}/sessions/${sessionId}`;

        this._baseUrl = orgStore.orgInfo?.resourceCentralEndpoint ?? "";

        const sessionData = {
          Language: settings?.language ?? "en-us",
          TimeZoneName: organizer?.TimeZoneStandardName || "",
          // Guid: currentAppointment.ItemId,
          Guid: OldResource?.orders?.haveNormalOrder ? OldResource?.orders?.guid : currentAppointment.Guid,
          ResourceAdId: selectedResources?.length > 0 ? selectedResources.map((rs) => rs.adId).join(",") : currentAppointment.ItemId,
          NewStartDate: currentAppointment.StartTimeTicks?.toString(),
          clientTimeFormat: settings?.dateTimeFormat.timeFormat ?? "",
          clientDateFormat: formatDateToRc(settings?.dateTimeFormat.dateFormat ?? ""), // Replace DD with ddsettings?.dateTimeFormat.dateFormat ?? "",
          clientSeparatorDate: settings?.dateTimeFormat.dateSeparator ?? "",
          clientCultureCode: settings?.language ?? "en-us",
          Token: this.accessToken,
          RcEndpoint: this._baseUrl,
        };

        this.http.post(urlSaveDataSession, sessionData);

        const dialogUrl = `${config.URL_ENDPOINT}/view-order?sessionId=${sessionId}`;

        this._dialogService.ShowDialog(dialogUrl, { Width: 50, Height: 50 }, (dialog: IDialogModel) => {
          if (dialog) {
            dialog.addEventHandler(DialogEventType.DialogEventReceived, (args: any) => {
              if (args.error == DialogErrorCode.Closed) {
                resolve();
              }
            });

            dialog.addEventHandler(DialogEventType.DialogMessageReceived, (args: any) => {
              if (args.message) {
                const message = JSON.parse(args.message) as DialogMessageBase;
                if (message.MessageType === OfficeDialogMessageType.CloseDialog) {
                  resolve();
                  dialog.close();
                }
              }
            });
          }
        });
      }
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private async _processPlaceOrderDialog(
    disableOrderForm: boolean,
    currentResource: ResourceInfo,
    selectedResources: ResourceInfo[],
    attendees: AttendeeInfo[],
    settings: ISettingStore,
    orgStore: IOrganizationStore
  ) {
    if (selectedResources && selectedResources.length > 0) {
      selectedResources = selectedResources.filter((rs: any) => !rs.IsLightResource); // Specify the correct type
      const listResourceConflictInstances = selectedResources.filter((rs: any) => rs.ConflictInstances && rs.ConflictInstances.length > 0);
      if (selectedResources && selectedResources.length > 0) {
        const selectedResourceAdIds = selectedResources?.length > 0 ? selectedResources.map((rs: ResourceInfo) => rs.adId).join(",") : "";
        const selectedResourcesStr = selectedResources?.length > 0 ? selectedResources.map((rs: ResourceInfo) => rs.guid).join(",") : "";

        // get booking information.
        const appointment = this._olAptService.GetCurrentAppointment();
        const organizer = await this._olOrganizerService.GetCurrentOrganizer();

        if (appointment && organizer) {
          const _attendees = attendees.filter((at: any) => at.email.toLowerCase() !== organizer.Email.toLowerCase()) || [];

          const occurrences: number[] = [];
          let isRecurringApp = false;
          let recurringInstances = "";
          let isHaveConflictInstance = false;
          const conflictResourcesOccurrencesMap: IHash<number[]> = {};

          if (appointment.IsRecurringMaster) {
            isRecurringApp = true;

            if (appointment.Occurrences) {
              const allOccurrences: number[] = [];
              const allDates = new Map<string, number>();

              appointment.Occurrences.forEach((oc) => {
                const dateKey = moment(oc.Start).format("DD/MM/YYYY");
                allOccurrences.push(oc.StartTicks);
                allDates.set(dateKey, oc.StartTicks);
              });

              const meetingDeclines = currentResource?.permission?.meetingDeclines || [];

              if (meetingDeclines.length > 0) {
                isHaveConflictInstance = true;

                meetingDeclines.forEach((md) => {
                  const startTimeDate = new Date(md.startTime);
                  const netTicks = convertToNetTicks(startTimeDate);
                  const key = currentResource.adId;
                  const keyDate = moment(md.startTime).format("DD/MM/YYYY");

                  if (!conflictResourcesOccurrencesMap[key]) {
                    conflictResourcesOccurrencesMap[key] = [];
                  }
                  conflictResourcesOccurrencesMap[key].push(netTicks);
                  allDates.delete(keyDate);
                });

                occurrences.length = 0;
                Array.from(allDates.values()).forEach((ticks) => {
                  occurrences.push(ticks);
                });

                recurringInstances = occurrences.join(";");
              } else {
                occurrences.push(...allOccurrences);
                recurringInstances = allOccurrences.join(";");
              }
            }
          }

          this._baseUrl = orgStore.orgInfo?.resourceCentralEndpoint ?? "";

          const payload: SaveSessionDataRequest = {
            BaseUrl: `${this._baseUrl}/ResourceCentral/api/OfficeApp/SaveSessionData`,
            SessionData: {
              SessionId: appointment?.SessionId ?? "",
              Attendees: _attendees.map((att: any) => {
                return {
                  Email: att.Email,
                  Name: att.Name,
                };
              }),
              RecurringInstances: isRecurringApp ? occurrences.join(";") : "",
              ConflictResourcesOccurrencesMap: isHaveConflictInstance ? JSON.stringify(conflictResourcesOccurrencesMap) : "",
            },
          };

          this.fetchSaveSessionDataRc(payload)
            .catch(() => {
              this._isPlacedOrderDialogShown = false;
            })
            .then(async () => {
              if (!disableOrderForm) {
                const sessionId = v4();

                const urlSaveDataSession: string = `${config.API_URL}/sessions/${sessionId}`;

                if (!this.accessToken) {
                  const accessToken = await this._authenticationService.GetCallbackToken();
                  this.accessToken = accessToken;
                }

                // const iCalUid =
                //   orgStore.orgInfo?.iCalUIds?.length && orgStore.orgInfo?.iCalUIds[0] && orgStore.orgInfo?.iCalUIds[0].iCalUids?.length
                //     ? orgStore.orgInfo?.iCalUIds[0].iCalUids[0]
                //     : orgStore.orgInfo?.uidOutlook;

                // const iCalUid =
                //   orgStore.orgInfo?.iCalUIds?.length && orgStore.orgInfo?.iCalUIds[0] && orgStore.orgInfo?.iCalUIds[0].iCalUids?.length
                //     ? orgStore.orgInfo?.iCalUIds[0].iCalUids[0]
                //     : currentResource.uuid;

                const iCalUid = orgStore.orgInfo?.iCalUIds?.find((item) => item.adId === currentResource.adId)?.iCalUids[0] || currentResource.uuid;

                const sessionData = {
                  SessionId: appointment.SessionId ?? "",
                  Attendees: _attendees.map((att: any) => {
                    return {
                      Email: att.Email,
                      Name: att.Name,
                    };
                  }),
                  SelectedResourceAdIds: currentResource.adId || selectedResourceAdIds,
                  RecurringInstances: isRecurringApp ? recurringInstances : "",
                  ConflictResourcesOccurrencesMap: isHaveConflictInstance ? JSON.stringify(conflictResourcesOccurrencesMap) : "",
                  SelectedResources: currentResource.guid || selectedResourcesStr,
                  StartTime: appointment.StartTimeTicks?.toString(),
                  EndTime: appointment.EndTimeTicks?.toString(),
                  Subject: encodeURIComponent(appointment.Subject),
                  OrganizerEmail: organizer.Email,
                  OrganizerName: organizer.Name,
                  TimeZoneCode: organizer?.TimeZoneStandardName || "",
                  CustomUid: iCalUid,
                  Guid: currentResource?.orders?.haveNormalOrder ? currentResource?.orders?.guid : appointment.Guid,
                  Language: settings?.language ?? "en-us",
                  GlobalId: appointment.ItemId || appointment.GlobalId,
                  // ReOpenOrderFormAfterSend: appointment.IsReopenAfterSent ? "1" : "0",
                  ReOpenOrderFormAfterSend: currentResource?.orders?.haveNormalOrder ? "1" : "0",
                  clientTimeFormat: settings?.dateTimeFormat.timeFormat ?? "",
                  clientDateFormat: formatDateToRc(settings?.dateTimeFormat.dateFormat ?? ""), // Replace DD with ddsettings?.dateTimeFormat.dateFormat ?? "",
                  clientSeparatorDate: settings?.dateTimeFormat.dateSeparator ?? "",
                  clientCultureCode: (settings?.language || "en-us") ?? "",
                  IsRecurringApp: appointment.IsRecurringMaster ? "1" : "0",
                  OriginalStartTime: !appointment.IsRecurringMaster && appointment.IsOccurence ? appointment.OriginalStart : "",
                  OriginalEndTime: !appointment.IsRecurringMaster && appointment.IsOccurence ? appointment.OriginalEnd : "",
                  Token: this.accessToken,
                  RcEndpoint: this._baseUrl,
                };

                await this.http.post(urlSaveDataSession, sessionData); // Use the sessionData object here

                const dialogUrl = `${config.URL_ENDPOINT}/order?sessionId=${sessionId}`;

                // this._dialogService.SetCustomProps("isOpenOrderForm", "true");
                // const dialogUrl = ApiUrl.GetPlaceOrderUrl(parameters);

                this._dialogService.ShowDialog(
                  dialogUrl,
                  {
                    Width: 86,
                    Height: 86,
                  },
                  this._showPlaceOrderDialogCallBack.bind(this) // Ràng buộc 'this' đến instance của OrderService
                );
              }
            });

          // // send all attendees to API.
          // this.SavePlaceOrderSessionData(orgStore.orgInfo?.resourceCentralEndpoint, {
          //   SessionId: appointment.SessionId ?? "",
          //   Attendees: attendees.map((att: any) => {
          //     return {
          //       Email: att.Email,
          //       Name: att.Name,
          //     };
          //   }),
          //   RecurringInstances: isRecurringApp ? occurrences.join(";") : "",
          //   ConflictResourcesOccurrencesMap: isHaveConflictInstance ? JSON.stringify(conflictResourcesOccurrencesMap) : "",
          // })
          //   .catch(() => {
          //     this._isPlacedOrderDialogShown = false;
          //   })
          //   .then(async () => {
          //     const parameters: IHash<string> = {};
          //     if (appointment && organizer && !disableOrderForm) {
          //       this._isPlacedOrderDialogShown = true;

          //       parameters["SelectedResources"] = selectedResourcesStr;
          //       if (appointment.StartTimeTicks) parameters["StartTime"] = appointment.StartTimeTicks.toString();
          //       if (appointment.EndTimeTicks) parameters["EndTime"] = appointment.EndTimeTicks.toString();
          //       if (appointment.Subject) parameters["Subject"] = encodeURIComponent(appointment.Subject);
          //       parameters["OrganizerEmail"] = organizer.Email;
          //       parameters["OrganizerName"] = organizer.Name;
          //       parameters["TimeZoneCode"] = "OrganizerTimeZoneStandardName";
          //       parameters["CustomUid"] = appointment.Uid;
          //       parameters["Language"] = "Language";
          //       if (appointment.SessionId) parameters["SessionId"] = appointment.SessionId;
          //       parameters["GlobalId"] = appointment.GlobalId;
          //       parameters["Guid"] = appointment.Guid;
          //       parameters["ReOpenOrderFormAfterSend"] = appointment.IsReopenAfterSent ? "1" : "0";
          //       if (settings) {
          //         parameters["clientTimeFormat"] = settings.timeFormat ?? "";
          //         parameters["clientDateFormat"] = settings.dateFormat ?? "";
          //         parameters["clientSeparatorDate"] = settings.dateFormat ?? "";
          //         parameters["clientCultureCode"] = settings.language ?? "";
          //       }
          //       parameters["IsRecurringApp"] = appointment.IsRecurringMaster ? "1" : "0";

          //       // if (appointment.IsRecurringMaster) {
          //       //   // if (appointment.RecurringAppDuration) parameters["RecurringAppDuration"] = appointment.RecurringAppDuration;
          //       //   if (appointment.Occurrences) {
          //       //     const ocurrences: number[] = [];
          //       //     const dates: string[] = [];

          //       //     appointment.Occurrences.forEach((oc) => {
          //       //       ocurrences.push(oc.StartTicks);
          //       //       dates.push(moment(oc.Start).format("DD/MM/YYYY")); // Định dạng ngày theo kiểu 9/23/2024
          //       //     });

          //       //     const payload = {
          //       //       ResourceId: Number(selectedResources[0]?.Id),
          //       //       RecurringDateInstances: ocurrences,
          //       //       StartTime: appointment.StartTimeTicks,
          //       //       EndTime: appointment.EndTimeTicks,
          //       //       UID: appointment.Uid,
          //       //       GlobalId: appointment.GlobalId,
          //       //       TimeZoneName: this._appSettingsService.OrganizerTimeZoneStandardName,
          //       //       DateFormat: this._appSettingsService.StandardDateTimeFormat.DateFormat,
          //       //       Duration: "",
          //       //       OrganizerEmail: organizer.Email,
          //       //       Attendees: "",
          //       //       IsResourceWorkSpace: selectedResources[0]?.IsWorkspace,
          //       //       AllowConflict: selectedResources[0]?.AllowConflictMeeting,
          //       //       IsRecurring: appointment.IsRecurringMaster ? 1 : 0,
          //       //     };

          //       //     const CheckConflictResourceItem = await this._bookingRepository.GetConflictInstancesInfo(payload);

          //       //     // Check if dates and CheckConflictResourceItem are valid before filtering
          //       //     const availableDates =
          //       //       Array.isArray(dates) && dates.length > 0 && Array.isArray(CheckConflictResourceItem) && CheckConflictResourceItem.length > 0
          //       //         ? dates.filter((date) => !CheckConflictResourceItem.some((item) => item.ConflictDateFormated === date))
          //       //         : []; // Default to empty array if checks fail

          //       //     console.log(availableDates);
          //       //     if (availableDates.length > 0) {
          //       //       const availableDatesString = availableDates.join(";");
          //       //       console.log(availableDatesString);
          //       //       parameters["RecurringInstances"] = availableDatesString;
          //       //     }

          //       //     // parameters["RecurringInstances"] = ocurrences.join(";");

          //       //     // const ocurrences: number[] = [];
          //       //     // appointment.Occurrences.forEach((oc) => {
          //       //     //   ocurrences.push(oc.StartTicks);
          //       //     // });
          //       //     // parameters["RecurringInstances"] = ocurrences.join(";");
          //       //   }
          //       // }

          //       if (!appointment.IsRecurringMaster && appointment.IsOccurence) {
          //         parameters["OriginalStartTime"] = appointment.OriginalStart;
          //         parameters["OriginalEndTime"] = appointment.OriginalEnd;
          //       }
          //       const sessionId = v4();

          //       const urlSaveDataSession: string = `${config.API_URL}/sessions/${sessionId}`;

          //       // Create parameters object for the POST request
          //       const sessionData = {
          //         SessionId: appointment.SessionId ?? "",
          //         Attendees: "",
          //         RecurringInstances: isRecurringApp ? occurrences.join(";") : "",
          //         ConflictResourcesOccurrencesMap: isHaveConflictInstance ? JSON.stringify(conflictResourcesOccurrencesMap) : "",
          //         SelectedResources: selectedResourcesStr,
          //         StartTime: appointment.StartTimeTicks?.toString(),
          //         EndTime: appointment.EndTimeTicks?.toString(),
          //         Subject: encodeURIComponent(appointment.Subject),
          //         OrganizerEmail: organizer.Email,
          //         OrganizerName: organizer.Name,
          //         TimeZoneCode: "OrganizerTimeZoneStandardName",
          //         CustomUid: appointment.Uid,
          //         Language: "Language",
          //         GlobalId: appointment.GlobalId,
          //         Guid: appointment.Guid,
          //         ReOpenOrderFormAfterSend: appointment.IsReopenAfterSent ? "1" : "0",
          //         clientTimeFormat: settings?.timeFormat ?? "",
          //         clientDateFormat: settings?.dateFormat ?? "",
          //         clientSeparatorDate: settings?.dateFormat ?? "",
          //         clientCultureCode: settings?.language ?? "",
          //         IsRecurringApp: appointment.IsRecurringMaster ? "1" : "0",
          //         OriginalStartTime: !appointment.IsRecurringMaster && appointment.IsOccurence ? appointment.OriginalStart : undefined,
          //         OriginalEndTime: !appointment.IsRecurringMaster && appointment.IsOccurence ? appointment.OriginalEnd : undefined,
          //       };

          //       await this.http.post(urlSaveDataSession, sessionData); // Use the sessionData object here

          //       const dialogUrl = `${config.URL_ENDPOINT}/order?sessionId=${sessionId}`;

          //       // this._dialogService.SetCustomProps("isOpenOrderForm", "true");
          //       // const dialogUrl = ApiUrl.GetPlaceOrderUrl(parameters);
          //       this._dialogService.ShowDialog(
          //         dialogUrl,
          //         {
          //           Width: 86,
          //           Height: 86,
          //         },
          //         this._showPlaceOrderDialogCallBack
          //       );
          //     }
          //   });
        }
      }
    }
  }

  private _showPlaceOrderDialogCallBack = (dialog: IDialogModel) => {
    // Sử dụng arrow function
    if (dialog) {
      this._placeOrderDialogHandler = dialog;
      dialog.addEventHandler(DialogEventType.DialogEventReceived, (args: any) => {
        //console.log(args, "Message from child");
        if (args.error === DialogErrorCode.Closed) {
          const appointment = this._olAptService.GetCurrentAppointment();
          if (appointment) {
            // case user click to close dialog button
            if (appointment.SessionId) {
              const payload: ClearSessionDataRequest = {
                BaseUrl: `${this._baseUrl}/ResourceCentral/api/OfficeApp/ClearSessionData`,
                SessionData: {
                  SessionId: appointment?.SessionId ?? "",
                },
              };

              this.fetchClearSessionDataRc(payload);
            }
            this._placeOrderDialogHandler = null;
            this._isPlacedOrderDialogShown = false;
          }
        }
      });
      // // eslint-disable-next-line @typescript-eslint/no-explicit-any
      dialog.addEventHandler(DialogEventType.DialogMessageReceived, (args: any) => {
        //console.log(args, "Message from child");
        if (args.message) {
          const message = JSON.parse(args.message) as DialogMessageBase;
          switch (message.MessageType) {
            case OfficeDialogMessageType.SavedReservations:
              // eslint-disable-next-line no-case-declarations
              const updateOrderMessage = message as UpdateOrderMessage;
              this._dialogService.SaveSessionDataDialog(updateOrderMessage.Ids);
              break;
            case OfficeDialogMessageType.CloseDialog:
              // eslint-disable-next-line no-case-declarations
              dialog.close();
              this._placeOrderDialogHandler = null;
              this._isPlacedOrderDialogShown = false;
              break;
            case OfficeDialogMessageType.UpdateAttendees:
              // eslint-disable-next-line no-case-declarations
              const updateAttendeesMsg = message as UpdateAttendeesMessage;
              this._updateRecipients(updateAttendeesMsg.Attendees, true);
              break;
          }
        }
      });
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private _updateRecipients(attendees: PlaceOrderDialogAttendee[], isFromOrder = false) {
    let recipients: OutlookRecipientDto[] = [];
    if (attendees != null && attendees.length > 0) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      recipients = attendees.map((attendee) => {
        return {
          Email: attendee.Email,
          Name: attendee.Name,
        };
      });
    }
    // const currentRecipients = this._resourceManager.GetCurrentRecipients();
    // const resources = currentRecipients.Attendees;
    // if (resources != null && resources.length > 0 && !isFromOrder) {
    //   recipients = recipients.concat(resources);
    // }
    // this._olAptService.SetRecipients({
    //   Recipients: recipients,
    // });
  }

  async ProcessWorkspaceRules(selectedRs: ResourceInfo[]): Promise<ProcessWorkspaceRulesResult> {
    const result: ProcessWorkspaceRulesResult = {
      IncludeWorkspace: false,
    };
    if (selectedRs && selectedRs.length > 0) {
      selectedRs.forEach(() => {
        // if (sr.IsWorkspace) {
        //   result.IncludeWorkspace = true;
        //   return false;
        // }
        return false;
      });
    }
    await this._olAptService.UpdateBodyForSendToAll(this._bookingEditSessionKey, result.IncludeWorkspace);
    return result;
  }

  public async CheckMovingOrderCondition(request: ProcessMovingOrderRequest): Promise<MovingOrderSessionModel | undefined> {
    let result: MovingOrderSessionModel | undefined;

    const checkResourcesResult: CheckResourceMovingOrderResult | undefined = this._checkResourceMovingOrder(request);

    const checkSuitableResult: CheckResourceSuitableForMovingOrderResponse | undefined = await this._checkResourcesSuitableForMoving(request.Request);

    if (checkSuitableResult != undefined) {
      switch (checkSuitableResult.MovingOrderType) {
        case CheckSuitableForMovingOrderEnum.PartialSuitable:
        case CheckSuitableForMovingOrderEnum.TotalSuitable:
        case CheckSuitableForMovingOrderEnum.Deadline:
        case CheckSuitableForMovingOrderEnum.DeadlineStopMoving:
        case CheckSuitableForMovingOrderEnum.Holiday:
          if (checkSuitableResult.MovingOrderType === CheckSuitableForMovingOrderEnum.TotalSuitable || checkSuitableResult.MovingOrderType === CheckSuitableForMovingOrderEnum.PartialSuitable) {
            checkResourcesResult.IsMoveable = true;
          }
          result = {
            ResourcesCalculated: checkResourcesResult,
            SuitableEnum: checkSuitableResult.MovingOrderType,
            Message: this._buildMovingOrderMessage(checkSuitableResult),
            Buttons: this._buildMovingOrderDialogButton(checkSuitableResult.MovingOrderType),
          };
          break;
        default:
          break;
      }
    }
    return result;
  }

  public async IsAllowMovingOrder(request: ProcessMovingOrderRequest): Promise<boolean> {
    let result = false;
    const checkResourcesResult: CheckResourceSuitableForMovingOrderResponse | undefined = await this._checkResourcesSuitableForMoving(request.Request);
    console.log("🚀 ~ OrderService ~ IsAllowMovingOrder ~ checkResourcesResult:", checkResourcesResult);

    if (checkResourcesResult?.MovingOrderType === CheckSuitableForMovingOrderEnum.TotalSuitable || checkResourcesResult?.MovingOrderType === CheckSuitableForMovingOrderEnum.PartialSuitable) {
      result = true;
    }
    return result;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // public IsAllowMovingOrder(request: ProcessMovingOrderRequest): boolean {
  //   let result = false;
  //   const checkResourcesResult = this._checkResourceMovingOrder(request);
  //   if (checkResourcesResult.IsMoveable) {
  //     result = true;
  //   }
  //   return result;
  // }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars

  private _checkResourceMovingOrder(request: ProcessMovingOrderRequest): CheckResourceMovingOrderResult {
    const result: CheckResourceMovingOrderResult = { IsMoveable: false };

    const [currentResource] = request.CurrentSelected ?? [];
    const [originalResource] = request.OriginalSelected ?? [];

    if (currentResource && originalResource && currentResource.guid !== originalResource.guid) {
      result.OldResource = originalResource;
      result.NewResource = currentResource;
    }

    return result;
  }

  public async _checkResourcesSuitableForMoving(checkResourcesResult: OrderDataRequest): Promise<CheckResourceSuitableForMovingOrderResponse | undefined> {
    const rcResourceService: IRcResourceService = baContainer.resolve(TokenIRcResourceService);

    const checkResult = await rcResourceService.fetchCheckExternalResourcesSuitableForMovingOrder(checkResourcesResult);
    const rs: CheckResourceSuitableForMovingOrderResponse = {
      MovingOrderType: checkResult.data.MovingOrderType,
      ItemAvailable: checkResult.data?.ItemAvailable || false,
    };
    console.log("🚀 ~ OrderService ~ _checkResourcesSuitableForMoving ~ rs:", rs);
    return rs;
  }

  private _buildMovingOrderMessage(checkSuitable: CheckResourceSuitableForMovingOrderResponse): string {
    let message = "";
    const replacePattern = new RegExp("<br/>", "g");
    const textLineBreak = "\\r\\n";
    const additionalMsg = "If you select 'Yes' the order will be transferred to the resource you have selected. If you select 'No', the order will be canceled.";

    const additionalMsgYes = "If you select 'Yes', the available parts of the order will be move to the new resource.";
    const additionalMsgNo = "If you select 'No' the order will be cancelled when moving the meeting to the new resouce.";

    const nonAvailable =
      "You are moving your meeting to another resource.<br/><br/>The new resource may not offer the same items and/or extra services, or some of the items may not be available due to deadlines. Please check the new order , to see the impact";

    const additionalMsgYesDeadline = "If you select 'Yes', the available parts of the order will be moved to the new resource. Additional order changes can be done when the order has been moved.";
    const additionalMsgNoDeadline = "If you select 'No', the order will be cancelled when moving the meeting to the new resource.";

    switch (checkSuitable.MovingOrderType) {
      case CheckSuitableForMovingOrderEnum.DeadlineStopMoving:
        message = "The order in the reservation you are moving cannot be moved because the deadline for ordering services has passed.<br/>Do you still want to proceed ?".replace(
          replacePattern,
          textLineBreak
        );
        break;

      // case CheckSuitableForMovingOrderEnum.Deadline:
      //   if (OrderDeadlineStopMovingOrder) {
      //     message = "The order in the reservation you are moving cannot be moved because the deadline for ordering services has passed.<br/>Do you still want to proceed ?".replace(
      //       replacePattern,
      //       textLineBreak
      //     );
      //   } else {
      //     message =
      //       "You are moving the meeting to another resouce.<br/>The new resource may not offer the same items and/or extra services, or some of the items may not be avaible due to deadlinse. Please check the new order to see the impact.".replace(
      //         replacePattern,
      //         textLineBreak
      //       ) +
      //       textLineBreak +
      //       textLineBreak +
      //       additionalMsgYesDeadline +
      //       textLineBreak +
      //       additionalMsgNoDeadline;
      //   }
      //   break;

      case CheckSuitableForMovingOrderEnum.TotalSuitable:
        message = "You are moving your meeting to another resource. Do you also want to move your order?" + textLineBreak + textLineBreak + additionalMsg;
        break;

      case CheckSuitableForMovingOrderEnum.PartialSuitable:
        if (checkSuitable.ItemAvailable) {
          message =
            "You are moving your meeting to another resource.<br/><br/>The new resource does not have the same items and/or extra services, or some of the items might be inactive.<br/><br/>Do you want to create an order for the new resource?".replace(
              replacePattern,
              textLineBreak
            );
        } else {
          message = nonAvailable.replace(replacePattern, textLineBreak) + textLineBreak + textLineBreak + additionalMsgYes + textLineBreak + additionalMsgNo;
        }
        break;

      case CheckSuitableForMovingOrderEnum.Holiday:
        message =
          "You are moving your meeting to another resource.<br/><br/>The existing order will be cancelled because ordering is not possible at this location due to a holiday.<br/><br/>Do you want to proceed?".replace(
            replacePattern,
            textLineBreak
          );
        break;

      case CheckSuitableForMovingOrderEnum.NotSupport:
        message =
          "You are moving your meeting to another resource.<br/><br/>The existing order will be cancelled because the new resource does not support ordering.<br/><br/>Do you want to proceed?".replace(
            replacePattern,
            textLineBreak
          );
        break;
    }
    return message;
  }

  private _buildMovingOrderDialogButton(checkSuitable: CheckSuitableForMovingOrderEnum): IAlertButton[] {
    let alertButtons: IAlertButton[] = [];
    const btnYes: IAlertButton = {
      id: "btnYes",
      text: "Yes",
      value: DialogChosenEnum.Yes,
    };
    const btnNo: IAlertButton = {
      id: "btnNo",
      text: "No",
      value: DialogChosenEnum.No,
    };
    if (checkSuitable === CheckSuitableForMovingOrderEnum.DeadlineStopMoving || checkSuitable === CheckSuitableForMovingOrderEnum.Holiday) {
      alertButtons = [btnYes, btnNo];
    } else {
      const btnViewOrder: IAlertButton = {
        id: "btnViewOrder",
        text: "View Order",
        value: DialogChosenEnum.ViewOrder,
      };
      alertButtons = [btnYes, btnNo, btnViewOrder];
    }
    return alertButtons;
  }

  get IsShownDeadlineMessage() {
    return this._isShownDeadlineMessage;
  }

  set IsShownDeadlineMessage(val: boolean) {
    this._isShownDeadlineMessage = val;
  }

  fetchSessionData = (sessionId: string): Promise<HttpResponse<any>> => {
    const urlGetDataSession: string = `${config.API_URL}/sessions/${sessionId}`;
    return this.http
      .get(urlGetDataSession)
      .then((resp: AxiosResponse<{ data: any }>) => {
        const response = {
          ...resp,
          data: resp.data?.data,
        };
        return new HttpResponse<any>(response);
      })
      .catch((err) => new HttpResponse(err?.response));
  };

  fetchSaveSessionDataRc = (request: SaveSessionDataRequest): Promise<HttpResponse<any>> => {
    const _url: string = `${config.API_URL}/ResourceCentral/SaveSessionData`;
    return this.http
      .post(_url, request)
      .then((resp: AxiosResponse<{ data: any }>) => {
        const response = {
          ...resp,
          data: resp.data?.data,
        };
        return new HttpResponse<any>(response);
      })
      .catch((err) => new HttpResponse(err?.response));
  };

  fetchClearSessionDataRc = (request: ClearSessionDataRequest): Promise<HttpResponse<any>> => {
    const _url: string = `${config.API_URL}/ResourceCentral/ClearSessionData`;
    return this.http
      .post(_url, request)
      .then((resp: AxiosResponse<{ data: any }>) => {
        const response = {
          ...resp,
          data: resp.data?.data,
        };
        return new HttpResponse<any>(response);
      })
      .catch((err) => new HttpResponse(err?.response));
  };
}
